// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ff4500","secondColor":"#3f4956","activeColor":"#f4657d","blueColor":"#5b7be1","cancelColor":"#c8c9cc","statusColor":"#ed4133"};